import logoDark from '@/assets/logo.jpg';

interface Props {
  className?: string;
}

export function AppLogo({ className }: Props) {
  return (
    <div className={`flex items-center gap-2.5 ${className ?? ''}`}>
      <img src={logoDark} alt='LinkVideo' className='size-9 rounded-xl object-cover shrink-0' />
      <span className='text-[17px] font-semibold tracking-wide text-foreground'>
        Биллинг LinkVideo
      </span>
    </div>
  );
}
